import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")}</li>
            <li>
              <Link to="/dashboard" className=" ">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>

            <li>
              <Link to="/audit" className=" ">
                <i className="bx bx bx-money"></i>
                <span>{props.t("Audit")}</span>
              </Link>
            </li>

            <li>
              <Link to="/home-products" className=" ">
                <i className="bx bxl-product-hunt"></i>
                <span>{props.t("Project Product")}</span>
              </Link>
            </li>

            <li>
              <Link to="/projects-grid" className=" ">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Projects")}</span>
              </Link>
            </li>

            <li>
              <Link to="/projects-list" className=" ">
                <i className="bx bx-check-shield"></i>
                <span>{props.t("Project Confirms")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Stocks")}</li>
            <li>
              <Link to="/table-Material-Types" className=" ">
                <i className="mdi mdi-mirror"></i>
                <span>{props.t("Material Types")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-Material-Stocks" className=" ">
                <i className="mdi mdi-store-minus"></i>
                <span>{props.t("Material Stocks")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-Material-Shops" className=" ">
                <i className="mdi mdi-shopping"></i>

                <span>{props.t("Material Shops")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Moneys")}</li>
            <li>
              <Link to="/table-Money-Product" className=" ">
                <i className="bx bx-building"></i>
                <span>{props.t("Products")}</span>
              </Link>
            </li>

            {/* <li>
              <Link to="/table-Money-shppings" className=" ">
                <i className="bx bx-train"></i>
                <span>{props.t("Shppings")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-Money-wages" className=" ">
                <i className="bx bx-dollar"></i>
                <span>{props.t("Wages")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-Money-customer-receives" className=" ">
                <i className="bx bxs-wallet"></i>
                <span>{props.t("Customer Receive")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-Money-employees" className=" ">
                <i className="bx bx-dollar-circle"></i>
                <span>{props.t("Employees")}</span>
              </Link>
            </li> */}
            {/* <li className="menu-title">{props.t("Documents")}</li>
            <li>
              <Link to="/table-documents" className=" ">
                <i className="bx bx-dock-bottom"></i>
                <span>{props.t("Documents")}</span>
              </Link>
            </li> */}

            {/* <li className="menu-title">{props.t("Report")}</li>
            <li>
              <Link to="/table-report-wages" className=" ">
                <i className="bx bx-message-square-edit"></i>
                <span>{props.t("Wages")}</span>
              </Link>
            </li>
            <li>
              <Link to="/table-report-pos" className=" ">
                <i className="bx bx-message-square-minus"></i>
                <span>{props.t("Pos")}</span>
              </Link>
            </li>
            <li>
              <Link to="/table-report-withdraws" className=" ">
                <i className="bx bx-archive-out"></i>
                <span>{props.t("Withdraws")}</span>
              </Link>
            </li>
            <li>
              <Link to="/table-report-attendances" className=" ">
                <i className="bx bx-stopwatch"></i>
                <span>{props.t("Attendances")}</span>
              </Link>
            </li>
            <li>
              <Link to="/table-report-employees" className=" ">
                <i className="bx bx-user-voice"></i>
                <span>{props.t("Employees")}</span>
              </Link>
            </li> */}

            {/*  <li className="menu-title">{props.t("Visitors")}</li>
            <li>
              <Link to="/table-company-infos" className=" ">
                <i className="bx bx-store-alt"></i>
                <span>{props.t("Company Info")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-prices" className=" ">
                <i className="bx bx-dollar"></i>
                <span>{props.t("Prices")}</span>
              </Link>
            </li>

       

            <li>
              <Link to="/table-materials" className=" ">
                <i className="bx bx-restaurant"></i>
                <span>{props.t("Materials")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-sumps" className=" ">
                <i className="bx bx-disc"></i>
                <span>{props.t("Sumps")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-provinces" className=" ">
                <i className="bx bx-stats"></i>
                <span>{props.t("Province")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-transits-warrantys" className=" ">
                <i className="bx bxs-truck"></i>
                <span>{props.t("Transits Warrantys")}</span>
              </Link>
            </li> */}

            <li className="menu-title">{props.t("Constructions")}</li>

            <li>
              <Link to="/table-design-groups" className=" ">
                <i className="bx bx-message-square-x"></i>
                <span>{props.t("Design Groups")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-qcs" className=" ">
                <i className="bx bx-message-square-check"></i>
                <span>{props.t("Qcs")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-custom-projects" className=" ">
                <i className="bx bx-message-rounded-x"></i>
                <span>{props.t("Custom Projects")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-list-structure" className=" ">
                <i className="bx bx-building-house"></i>
                <span>{props.t("Boqs")}</span>
              </Link>
            </li>

            <li>
              <Link to="/table-contractors" className=" ">
                <i className="bx bx-user-voice"></i>
                <span>{props.t("Contractors")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Settings")}</li>

            <li>
              <Link to="/table-users" className=" ">
                <i className="bx bx-user"></i>
                <span>{props.t("Users")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
